import React, { createRef, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Button, Container } from '@mui/material';
import { NodePlus } from 'react-bootstrap-icons';
import { AxiosResponse } from 'axios';
import { useTranslation } from 'react-i18next';
import $ from 'jquery';
import Loader from '../../common-components/loader';
import constants from '../../constants';
import TableView from '../../Components/tableView';
import { ReactComponent as AlgoLogo } from '../../images/algorand_logo_mark_black.svg';
import { initKycAccount } from '../../api/kyc';

const Kyc = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const kycTable = createRef<TableView>();

  const initAccount = async (e: JQuery.ClickEvent) => {
    setLoading(true);
    const mail = e.currentTarget.id;
    e?.stopPropagation();
    try {
      const result: AxiosResponse = await initKycAccount(mail);
      if (result.data.success === true) {
        kycTable.current?.reloadData();
      }
    } catch (error: any) {
      console.log(error.response.data.errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const addIcon = (cell: any) => {
    const { algos, mail } = cell.getRow().getData();
    let res;
    if (algos === undefined || algos === null) {
      res = '-';
    } else if (algos === 0) {
      res = ReactDOMServer.renderToString(
        <>
          {algos}
          <Button className="init-account-btn" id={mail}>
            <AlgoLogo height={20} />
            <NodePlus />
          </Button>
        </>
      );
    } else {
      res = algos / 1000000;
    }
    return res;
  };

  const formatPlanets = (cell: any) => {
    const { planets } = cell.getRow().getData();
    if (planets === undefined || planets === null) {
      return '-';
    }
    return planets / 1000000;
  };

  const tableBuilt = () => {
    console.log('Built');
    $('.init-account-btn').on('click', initAccount);
  };

  const columns = [
    {
      title: t('MAIL'),
      field: 'mail',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('ALGORAND_ACCOUNT'),
      field: 'algo_account',
      sorter: 'string',
      headerFilter: 'input'
    },
    { title: t('ALGORAND_BALANCE'), headerSort: false, formatter: addIcon },
    {
      title: t('PLANET_BALANCE'),
      headerSort: false,
      headerFilter: false,
      formatter: formatPlanets
    },
    {
      title: t('ETHEREUM_ACCOUNT'),
      field: 'ethereum_account',
      sorter: 'string',
      headerFilter: 'input'
    },
    {
      title: t('COMPLETED'),
      field: 'synaps_completed',
      sorter: 'number',
      headerFilter: 'input'
    }
  ];

  return (
    <Container>
      <Loader fullscreen={true} visible={loading} />
      <TableView
        t={t}
        ref={kycTable}
        api={constants.api.getKycInfos}
        id={'kyc'}
        columns={columns}
        tableProps={{ renderComplete: tableBuilt }}
      />
    </Container>
  );
};

export default Kyc;
